$.fn.centerVertically = function( dimensions ) {
	var heightOffset = 54; // 15px padding * 2 + 24px for format.

	var eles = this;

	for( var i = 0, len = eles.length; i < len; i += 1 ) {
		var $container = $( eles.get( i ) );
		var $image = $container.find( "img" );

		var width = $container.data( 'original-width' );
		var height = $container.data( 'original-height' );
		var ratio = height / width;
		var isDummy = !$container.data( 'real-jacket-loaded' );

		if( isDummy ) {
			ratio = 1.3425;
			width = dimensions.width;
			height = dimensions.height;
		}

		var MARGIN = dimensions.width * 0.1;

		if( height > width || height == width || isDummy ) {
			if( dimensions.width < width + MARGIN || isDummy ) {
				width = dimensions.width - MARGIN;
			}

			height = width * ratio;

			if( dimensions.height < height + MARGIN + heightOffset ) {
				height = dimensions.height - MARGIN - heightOffset;
				width = height / ratio;
			}
		} else {
			if( dimensions.height < height + MARGIN + heightOffset ) {
				height = dimensions.height - MARGIN - heightOffset;
			}

			width = height / ratio;

			if( dimensions.width < width + MARGIN ) {
				width = dimensions.width - MARGIN;
				height = width * ratio;
			}
		}

		var marginTop = ( dimensions.height - height - heightOffset ) / 2;

		$image.css( {
			"margin-top": marginTop,
			"height":     height,
			"width":      width
		} );
	}
};

$.fn.centerVertically2 = function() {
	var eles = this;

	for( var i = 0, len = eles.length; i < len; i += 1 ) {
		var image = $( eles.get( i ) );
		var height = image.height();
		var containerHeight = image.parent().height();

		image.css( {'margin-top': ( containerHeight - height ) / 2 } );
	}
};